import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
//import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootReducer } from "../../../../reducers";
import { updateAgencyRequest } from "../../../../actions";
import AgencyForm, { AgencyFormHandle, AgencyFormMode } from "../agency-form";
import { Agency } from "../../../../reducers/states/agency";
import { AgencyAdminStoreError, AgencyAdminStoreSuccess } from "../../../../enums/store-messages/admin";

interface EditAgencyProps {
  agencySelection: Agency;
  isEditBtnEnabled: boolean;
}

const EditAgencyModal: FC<EditAgencyProps> = (props) => {
  const dispatch = useDispatch();
  const store = useSelector((state: IRootReducer) => state.agencyReducer);
  const formRef = useRef<AgencyFormHandle>(null);

  // UI control
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [isOpen, setIsOpen] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleCancel = (event?: object, reason?: string) => {
    if (reason === "backdropClick") return false;
    setIsOpen(false);
    formRef.current?.reset();
  };

  const handleSubmit = () => {
    if (formRef.current) {
      setIsValid(false); // prevent submitting again
      const agency = formRef.current?.getValues();
      dispatch(updateAgencyRequest(agency));
    }
  };

  useEffect(() => {
    if (store.successMessage === AgencyAdminStoreSuccess.UPDATE_AGENCY_SUCCESS) {
      formRef.current?.reset();
      setIsOpen(false);
    } else if (store.failureMessage === AgencyAdminStoreError.UPDATE_AGENCY_ERROR) {
      setIsValid(true); // allow submitting again
    }
  }, [store.successMessage, store.failureMessage]);

  const handleValidityChanged = (newValue: boolean) => {
    setIsValid(newValue);
  }

  return (
    <>
      <Tooltip title="Edit the selected agency">
        {/* Wrapped in "Box" to avoid MUI console error for wrapping disabled element in Tooltip */}
        <Box>
          <Button
            disabled={!props.isEditBtnEnabled}
            color={props.isEditBtnEnabled ? "primary" : "inherit"}
            onClick={handleOpen}
            style={{ minWidth: "150px", color: props.isEditBtnEnabled ? "white" : "black" }}
            variant="contained"
          >
            Edit Agency
          </Button>
        </Box>
      </Tooltip>

      <Dialog
        fullScreen={fullScreen}
        fullWidth
        open={isOpen}
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Edit Agency</DialogTitle>
        <DialogContent className="create-edit-agency">
          <DialogContentText>
            Edit information as desired
          </DialogContentText>
          <AgencyForm ref={formRef} initialValue={props.agencySelection} mode={AgencyFormMode.EDIT} onValidityChanged={handleValidityChanged} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="inherit" variant="contained">
            Cancel
          </Button>
          <Button
            disabled={!isValid}
            onClick={handleSubmit}
            color="primary"
            variant="contained"
          >
            Save Agency
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditAgencyModal;
